
import React, { Component } from 'react';
import { Grid } from 'react-bootstrap';

import notFoundImage from '../images/404_image.png'

import { LogeButton, NavSpacer, Center, LightBackground, Black, BlackHeading1, GoldenLink } from '../components/GeneralStyle'

class ErrorNotFound404 extends Component {

  render() {
    return (
      <Grid fluid>
        <NavSpacer />
        <LightBackground>
          <Center style={{ padding: 50 }} className={"fillScreen"}>
            <img src={notFoundImage} alt={"404"} />
            <BlackHeading1>Hoppla, nicht gefunden, wonach Sie gesucht haben?</BlackHeading1>

            <Black>Bitte <GoldenLink onClick={() => this.props.history.push('/kontakt')}>kontaktieren</GoldenLink> Sie uns oder kehren Sie</Black>

            <LogeButton
              hoverFontColor={"white"}
              onClick={() => this.props.history.push('/')} 
              style={{ margin: 30 }}>zurück zur Homepage.</LogeButton>
            <br />

          </Center>
        </LightBackground>
      </Grid>
    );
  }
}


export default ErrorNotFound404;






// WEBPACK FOOTER //
// /src/pages/ErrorNotFound404.js